<div>
  <div class="mat-dialog-title-wrapper">
    <h1 mat-dialog-title>Stay Informed via SMS</h1>
  </div>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-sm-12">
        <p>
          By checking this box, you agree to receive SMS messages from OnyxIQ about your loan
          application, including status updates and important reminders. <br />
          Text STOP to opt out at any time, or HELP for assistance.
        </p>
        <mat-checkbox style="vertical-align: middle">
          I agree to receive SMS messages from OnyxIQ as described above.
        </mat-checkbox>
        <p style="margin-top: 20px">
          <small><strong>* </strong>Message & data rates may apply.</small> <br />
          <small><strong>* </strong>Message frequency varies.</small> <br />
        </p>
        <br />
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="accent" type="button" (click)="close()">Close</button>
  </div>
</div>
